"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderCellProvider = exports.TableHeaderCellContext = void 0;
var _react = require("react");
/**
 * Used by Table.Header, Table.Body and Table.HeaderCell.
 * Tells Table.HeaderCell whether it's inside of a Table.Header or a Table.Body.
 * Then, helps sets the appropriate `scope` attribute.
 */
var TableHeaderCellContext = /*#__PURE__*/(0, _react.createContext)({
  parent: ''
});
exports.TableHeaderCellContext = TableHeaderCellContext;
var TableHeaderCellProvider = TableHeaderCellContext.Provider;
exports.TableHeaderCellProvider = TableHeaderCellProvider;